<div class='container'>
  <ng-container *ngIf='isAuthenticationPage()'>
    <app-authentication-layout>
      <router-outlet></router-outlet>
    </app-authentication-layout>
  </ng-container>

  <ng-container *ngIf='isDashboardPage()'>
    <app-dashboard-layout>
      <router-outlet></router-outlet>
    </app-dashboard-layout>
  </ng-container>

  <ng-container *ngIf='isLoginCheckPage()'>
    <router-outlet></router-outlet>
  </ng-container>
</div>
